import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { InteriorAIPage } from './pages/InteriorAIPage';
render(<BrowserRouter data-id="element-576" data-mp="219642n9f89fm">
    <Routes data-id="element-577" data-mp="218mkz381bf00">
      <Route path="/" element={<App data-id="element-579" data-mp="269amiitw3e8h" />} data-id="element-578" data-mp="218wdoykgs09e" />
      <Route path="/interior-ai" element={<InteriorAIPage data-id="element-581" data-mp="26a258t2e1hhc" />} data-id="element-580" data-mp="2690ruhxwgiwg" />
    </Routes>
  </BrowserRouter>, document.getElementById('root'));